"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useFieldMappings(query) {
  const { ...rest } = useElements("field-mappings", query);
  return {
    fieldMappings: rest.items,
    ...rest
  };
}

export { useFieldMappings };
